module.exports = __webpack_public_path__ + "img/halp.99e1bd72.jpg";